import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";
import { api } from "../../lib/api";

export const ClearDataDialog = ({ count, onCleared }) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const clear = async () => {
    try {
      const r = await api.clearTests();
      toast.success(`Deleted ${r.deleted} tests`);
      setOpen(false); onCleared();
    } catch { toast.error("Failed to clear data"); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); setText(""); }}>
      <DialogTrigger asChild>
        <button data-testid="clear-data-button" className="btn-ghost flex items-center gap-1 text-xs hover:!text-[#FF3B30] hover:!border-[#FF3B30]/50"><Trash2 className="w-4 h-4" /> Clear data</button>
      </DialogTrigger>
      <DialogContent className="rounded-none bg-[#121212] border-[#FF3B30]/40 text-white font-mono" data-testid="clear-data-dialog">
        <DialogHeader><DialogTitle className="font-display text-3xl font-normal tracking-wide text-[#FF3B30]">Clear all test data</DialogTitle></DialogHeader>
        <DialogDescription className="text-xs text-neutral-400">
          Permanently deletes all {count} speed tests for every team. Issue criteria are kept. This cannot be undone.
        </DialogDescription>
        <label className="label mt-2">Type DELETE to confirm</label>
        <input data-testid="clear-data-confirm-input" value={text} onChange={(e) => setText(e.target.value)} className="field w-full" placeholder="DELETE" />
        <button data-testid="clear-data-submit" disabled={text !== "DELETE"} onClick={clear}
          className="py-3 mt-2 font-display text-2xl tracking-widest bg-[#FF3B30] text-white disabled:opacity-30 transition-opacity">Delete everything</button>
      </DialogContent>
    </Dialog>
  );
};
